<template>
  <div>
    <v-form v-model="valid" ref="searchForm">
      <v-card dark style="border-radius:10px;">
        <v-layout wrap row justify-space-between class="pa-3">
          <v-flex
            xs12
            sm2
            class="px-1 search__input"
            v-if="'district_id' in $store.state[action_method].config_path"
          >
            <v-layout column>
              <v-flex>District :</v-flex>
              <v-flex>
                <v-autocomplete
                  :loading="isLoadingDistrict"
                  v-model="
                    $store.state[action_method].config_path.district_id[0]
                  "
                  item-text="district_name_th"
                  item-value="district_id"
                  :items="districtList"
                  hide-details
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Status :</v-flex>
              <v-flex>
                <v-select
                  v-model="$store.state[action_method].config_path.order_status"
                  item-text="name"
                  item-value="value"
                  :items="order_status"
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Start :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%;"
                >
                  <v-text-field
                    slot="activator"
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    prepend-icon="event"
                    hide-details
                    readonly
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>End :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%;"
                >
                  <v-text-field
                    slot="activator"
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    prepend-icon="event"
                    hide-details
                    :rules="[rules.required]"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 style="display:flex;justify-content:center">
            <div class="pt-2 text-xs-center search-btn" @click="search()">
              <v-progress-circular
                indeterminate
                color="black"
                v-if="searching"
              ></v-progress-circular>
              <v-icon large color="black" v-else>search</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    action_method: {
      default() {
        return "fetchSaleMessengerReport";
      },
    },
  },
  data() {
    return {
      searching: false,
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
      },
      order_status: [
        { name: "Completed", value: "6" },
        { name: "Canceled", value: "7" },
      ],
      menu1: false,
      menu2: false,
      districtList: [
        {
          district_id: 0,
          district_name_th: "ทุกอำเภอ",
          district_name_en: "All district",
        },
      ],
      isLoadingDistrict: false,
    };
  },
  created() {
    this.fetchDistrictList();
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async fetchDistrictList() {
      this.isLoadingDistrict = true;
      let province = this.provinceData.find(
        (val) =>
          val.province_name_en.replace(/ /g, "").toLowerCase() ===
          this.provinceNameEn.toLowerCase()
      );
      let districtByProvince = await this.fetchDistrictCore(
        province.province_id
      );
      this.districtList = [...this.districtList, ...districtByProvince];
      this.isLoadingDistrict = false;
    },
    async search() {
      if (this.searching == false) {
        if (this.$refs.searchForm.validate()) {
          this.searching = true;
          if (
            this.$store.state[this.action_method].config_path.district_id[0] ==
            0
          ) {
            await this.$store.dispatch(
              this.action_method + "/fetchReportList",
              this.$store.state[this.action_method].config_path
            );
          } else {
            await this.$store.dispatch(
              this.action_method + "/fetchReportByDistrict"
            );
          }
          this.searching = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}

@media screen and (max-width: 662px) {
  .search__input {
    margin-bottom: 10px;
  }
}
</style>
